import { getCurrentBasic } from './core/ProgramService'

/**
 *
 * @description 圈子板块 - 浏览
 */
export async function reportCircleView(params: {
    /** 板块id */
    threadId: string

    /** 板块标题 */
    threadTitle: string
}) {
    window['sensors'].track(
        'KbPGCObjUserAct',
        Object.assign(await getCurrentBasic(), {
            business: 'CIRCLE',
            businessVer: 1,
            pageName: '车友圈板块页',
            pageUrl: window.location.href,

            ref1: params.threadId,
            ref1Title: params.threadTitle,
            ref1Name: '车友圈板块',

            view: 1,
        }),
    )
}
